import api from '../../../../api/client';
import React from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import useWindowSize from '../../../../hooks/useWindowSize';
import NavSearch from './NavSearch';
import { useSelector } from 'react-redux';

const NavLeft = () => {
    const account = useSelector((state) => state.account);
    const windowSize = useWindowSize();

    let dropdownRightAlign = false;

    let navItemClass = ['nav-item'];
    if (windowSize.width <= 575) {
        navItemClass = [...navItemClass, 'd-none'];
    }

    const generateGreeting = () => {
        const currentTime = new Date();
        const currentHour = currentTime.getHours();

        let greeting = '';

        if (currentHour < 12) {
            greeting = 'Good morning';
        } else if (currentHour >= 12 && currentHour < 18) {
            greeting = 'Good afternoon';
        } else {
            greeting = 'Good evening';
        }

        const userName = `${account.user.firstname} ${account.user.lastname}`; // Replace with the actual user's name

        return (
            <span>
                {greeting},{' '}
                <span className="text-success" style={{ fontWeight: 'bold' }}>
                    {userName}
                </span>
            </span>
        );
    };

    return (
        <React.Fragment>
            <ListGroup as="ul" bsPrefix=" " className="navbar-nav mr-auto" bac="success" backgroundColor="success">
                <ListGroup.Item as="li" bsPrefix=" " className={navItemClass.join(' ')}>
                    <Dropdown alignRight={dropdownRightAlign}>
                        {/* <Dropdown.Toggle variant={'link'} id="dropdown-basic">
                            Dropdown
                        </Dropdown.Toggle>
                        <ul>
                            <Dropdown.Menu>
                                <li>
                                    <Link to="#" className="dropdown-item">
                                        Action
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className="dropdown-item">
                                        Another action
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" className="dropdown-item">
                                        Something else here
                                    </Link>
                                </li>
                            </Dropdown.Menu>
                        </ul> */}
                        {generateGreeting()}
                    </Dropdown>
                </ListGroup.Item>
                {/* <ListGroup.Item as="li" bsPrefix=" " className="nav-item" variant="primary">
                    <NavSearch windowWidth={windowSize.width} />
                </ListGroup.Item> */}
            </ListGroup>
        </React.Fragment>
    );
};

export default NavLeft;
